import { render, staticRenderFns } from "./CardAlarm.vue?vue&type=template&id=7b0bc022&scoped=true&"
import script from "./CardAlarm.vue?vue&type=script&lang=js&"
export * from "./CardAlarm.vue?vue&type=script&lang=js&"
import style0 from "./CardAlarm.vue?vue&type=style&index=0&id=7b0bc022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0bc022",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
